module.exports = "/images/demo_cme.png?e5b7dd4e876b5356a02303238254414c";